import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FlatTextInput, useDebounce } from '@common-fe/common-fe';

import { useMyMoneyFormStore } from '@/modules/UseMyMoney/stores';

const ClaimNotes = () => {
  const { t } = useTranslation();
  const { values, handleSetFormValues } = useMyMoneyFormStore();

  const [notes, setNotes] = useState(values?.notes || '');
  const debouncedNotes = useDebounce(notes);
  
  useEffect(() => {
    handleSetFormValues({ notes: debouncedNotes });
  }, [handleSetFormValues, debouncedNotes]);

  return (
    <FlatTextInput
      testId="claim-notes"
      value={notes as string}
      onChange={setNotes}
      placeholder={t('Enter any helpful notes for the claim processor')}
      style={{ minHeight: '44px', overflow: 'hidden' }}
      inputType="textArea"
      name='claim-notes'
      hideTip
      maxLength={300}
    />
  );
};

export default ClaimNotes;
